<div class="{{ marginTopCss }}">
  <p
    #collapsible
    class="{{ textCss || '' }} mb-1"
    [ngClass]="showMoreText ? 'clamp-2' : ''"
    [innerHTML]="textKey | translate"
    [id]="uuid"
    [attr.aria-expanded]="!showMoreText"
  ></p>
  <p class="mb-0">
    <button
      class="btn btn-link btn-link--blue"
      mweClickPreventDefault
      (click)="toggleText()"
      [attr.aria-expanded]="!showMoreText"
      [attr.aria-controls]="uuid"
    >
      {{ (showMoreText ? showMoreKey : showLessKey) | translate }}
    </button>
  </p>
</div>
